// extracted by mini-css-extract-plugin
export default {"homePageTalukaHead":"TalukasUnderProgram_homePageTalukaHead__4fqd5","homeTalukaStats":"TalukasUnderProgram_homeTalukaStats__tclLL"};